<template lang="pug">
  header.header
    .header__inner
      //manager-select
      <!--.header-feed-search(v-if="$route.name !== 'map'")-->
        <!--img.header-feed-search__icon(src="../../assets/images/search-icon.png")-->
        <!--input.header-feed-search__input(-->
          <!--v-model="feedsSearch"-->
          <!--placeholder="Найти..."-->
        <!--)-->
      <!--header-nav(-->
        <!--:items="filteredFeeds"-->
        <!--v-if="$route.name !== 'map' && feeds.length"-->
      <!--)-->
      .header__title(v-if="feeds.length")
        .header__count Всего постов: {{ $store.state.threadInfo.threadFeedsCount }}
        | {{ title }}
      user-menu
      header-stat
</template>

<script>
import { getThreadsApi } from '@/api/posts';
import HeaderNav from '@/components/header/headerNav.vue';
import ManagerSelect from '@/components/header/managerSelect.vue';
import UserMenu from '@/components/header/userMenu.vue';
import HeaderStat from "@/components/header/headerStat.vue";

export default {
  name: 'headerMain',
  components: { HeaderStat, UserMenu, ManagerSelect, HeaderNav },
  data() {
    return {
      feeds: [],
      feedsSearch: '',
      title: process.env.VUE_APP_THREAD_NAME,
    };
  },
  computed: {
    filteredFeeds() {
      return this.feeds.filter(elem => elem.threadname.toLowerCase()
        .indexOf(this.feedsSearch.toLowerCase()) + 1);
    },
  },
  mounted() {
    this.getThreads();
  },
  methods: {
    getThreads() {
      getThreadsApi()
        .then((resp) => {
          this.feeds = resp.data;
        });
    },
  },
};
</script>

<style lang="stylus">
.header
  width 100%
  background #3a3a3a
  box-shadow 4px 0 10px rgba(0,0,0,.4)
  position relative
  &__inner
    margin 0 auto
    display flex
    align-items center
    padding 0 1em
    max-width 1440px
    flex-wrap wrap
    @media screen and (max-width 1000px) and (min-width 600px)
      flex-wrap nowrap
  &__count
    display block
    font-size .7em
    margin-bottom .4em
  &__title
    color #fff
    font-size 1.6em
    margin .8em auto .2em auto
    text-align center
    @media screen and (max-width 1000px) and (min-width 600px)
      order -2
  &-feed-search
    position relative
    width calc((100% + 2em) * .15)
    padding 0 1em
    margin-left -1em
    &__icon
      position absolute
      left 1.5em
      top 50%
      transform translate(0, -50%)
    &__input
      padding 0 0 0 2em
      line-height 2.4em
      box-shadow none
      outline none
      border none
      border-radius 4px
      max-width 100%
</style>
